const getAvailableMonitors = require('./available-monitors');

function setup({ allMonitors = [], project = 'blaze' } = {}) {
  const monitors = getAvailableMonitors({ allMonitors });

  monitors.forEach(monitor => monitor.setup(project));
}

module.exports = setup;
